<template>
  <FormModal title="Type aanvraag">
    <template #body>
      <MarketSegmentFormStep :progress-value="progressValue" />
    </template>
  </FormModal>
</template>

<script>
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import MarketSegmentFormStep from '~/components/form/steps/marketSegment/MarketSegmentFormStep'

export default {
  components: {
    MarketSegmentFormStep,
    FormModal,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Type opdracht',
      headDescription: 'Geef aan naar wat voor type schilder je op zoek bent.',
      path: '/offertes-aanvragen/type-opdracht',
      progressValue: 20,
      checkoutStep: 1,
    }
  },
}
</script>
